<script>
	import Tooltip from '$lib/tooltip/Tooltip.svelte';
	import { getShortAddress } from '$lib/util/util';
	import {
		loadingSmartContractWalletAuthorities,
		removingSmartContractWalletAuthorities,
		smartContractWalletAuthorities,
		walletAddress
	} from '$lib/wallet/store';
	import { onMount } from 'svelte';
	import { removeSmartContractWalletAuthority, setSmartContractWalletOwners } from '../scWallet';
	import ProcessingIcon from '$lib/util/ProcessingIcon.svelte';
	import { SC_EXECUTION_BOTS_CONTRACTS } from '$lib/web3/addresses';
	onMount(() => {
		setSmartContractWalletOwners();
	});
</script>

<div class="mt-3 mb-1">
	<div class="text-xs text-fx-grey-400">Existing Authorities</div>
</div>
<div class="border-t border-fx-grey-600" />
{#if $loadingSmartContractWalletAuthorities}
	<div
		class="w-full h-20 bgx-fx-grey-600 dark:bg-fx-grey-700 animate-pulse rounded-xl squircle-xl mt-2"
	/>
{:else}
	{#each $smartContractWalletAuthorities as authority}
		{#if !SC_EXECUTION_BOTS_CONTRACTS.includes(authority)}
			<div class="flex gap-2 h-full w-full px-2 py-1 items-center justify-between">
				<Tooltip title={authority} header="Address">
					<div class="w-full text-fx-grey-300 text-sm overflow-clip">
						{getShortAddress(authority)}
					</div>
				</Tooltip>

				{#if $removingSmartContractWalletAuthorities}
					<ProcessingIcon />
				{:else if authority != $walletAddress}
					<Tooltip
						title="This address will no longer have access to your Smart Contract wallet."
						header="Delete Authority"
					>
						<div
							class="hover:rotate-90 transition-all duration-200 cursor-pointer"
							on:click={() => {
								removeSmartContractWalletAuthority(authority);
							}}
							on:keydown={() => {
								removeSmartContractWalletAuthority(authority);
							}}
						>
							<img src="close.png" alt="delete" class="w-6" />
						</div>
					</Tooltip>
				{:else}
					<div class="text-fx-grey-400 text-sm">(Your account)</div>
				{/if}
			</div>
		{/if}
	{/each}
{/if}
